import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Feedback } from '@libs/src/feedback/feedback';

@Injectable({ providedIn: 'root' })
export class ConversationsBackend {
  private readonly v2ApiUrl = '/api/v2/account/conversations';
  v2 = {
    getAccountConversation: (conversationId: string) =>
      this.http.get(`${this.v2ApiUrl}/${conversationId}`),
    getAccountConversationConversationFeedback: (
      conversationId: string,
      queryParams: { [key: string]: any },
    ) =>
      this.http.get(
        `${this.v2ApiUrl}/${conversationId}/conversation_feedback`,
        { params: queryParams },
      ),
    postAccountConversationConversationFeedback: (
      conversationId: string,
      body: Feedback,
    ) =>
      this.http.post(
        `${this.v2ApiUrl}/${conversationId}/conversation_feedback`,
        body,
      ),
  };

  constructor(private http: HttpClient) {}
}
